import { endpoint } from 'services/endpoint';
import { http } from 'services/http';
import { TSupersetApi } from './types';

export const superset: TSupersetApi = {
	getSupersetDashboards: () =>
		http.get(endpoint.superset.DASHBOARDS).then((response) => response.data),
	getSupersetToken: (payload) =>
		http.post(endpoint.superset.TOKEN, payload).then((response) => response.data),
	// The embedded SDK is configured with an absolute guest token URL, so the request goes to that
	// URL directly instead of `endpoint.superset.TOKEN`. It still runs through `http` to keep the
	// auth/device-info interceptors.
	getSupersetTokenByUrl: (url, payload) =>
		http.post(url, payload).then((response) => response.data),
};
